<template>
  <div id="contenedor-eliminar-contrato-gasto">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Gasto </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar el gasto? </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarGasto"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixContratosGastos from './mixContratosGastos';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarContratoGasto',
  mixins: [mixContratosGastos],
  props: {
    contratoGastoEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
